<template>
    <v-app fixed>

        <Menu v-if="!isAppLevelRoute" :eventId="selectedEventId"/>

        <!-- Demo mode: stamp (same z-index as the welcome overlay below, which therefore covers it) and one-time hint -->
        <EspDemoStamp v-if="demoStamp && !isAppLevelRoute"/>
        <HLConfirm v-model="demoDialog" :title="$t('demoTitle')" :text="$t('demoMessage', { eventInLine: $tc('eventInLine', 1) })" icon="mdi-alert-circle-outline"/>

        <!-- Welcome Dialog Overlay -->
        <v-overlay :value="welcomeDialogOverlay" :dark="false" :opacity="0.85" z-index="6" ><!-- set 4 to show header -->
            <WelcomeDialogPage v-if="welcomeDialogOverlay" :style="`width:${bgWidth}px;`" @close="onCloseWelcomeDialog"/>
        </v-overlay>

        <!-- Snackbar -->
        <EspSnackbar v-model="notification"
                     ref="espSnackbar"
                     :text="notificationText"
                     :actionText="notificationActionText"
                     :actionCancelText="notificationActionCancelText"
                     :timeout="notificationTimeout"
                     :timeoutStart="notificationTimeoutStart"
                     @click="onSnackbarClick"
                     @cancel="onSnackbarCancel"
                     @outoftime="onSnackbarOutoftime"
        />

        <!-- Loading Mask -->
        <v-fade-transition v-if="event_single_loading">
            <v-overlay
                absolute
                color="#FFFFFF"
            >
                <v-progress-circular
                    :size="70"
                    color="primary"
                    indeterminate
                ></v-progress-circular>
            </v-overlay>
        </v-fade-transition>

        <!--
          <v-main v-if="event_single_loading">
          <v-container class="">
            <HLLoadingMask />
          </v-container>
        </v-main>
        -->


        <!-- the page gets the space between header and footer and scrolls inside itself, see the style below -->
        <div class="event-page">
            <keep-alive>
                <!-- <v-fade-transition :hide-on-leave="true" > --> <!-- if enabled: components initializes every time-->
                <router-view />
                <!--</v-fade-transition> -->

            </keep-alive>
        </div>

        <!-- QR scan and password input, opened from the power button or a list tap -->
        <EspCheckinActions @checkin="onCheckinSpotVerified"/>

        <!-- overflow of the footer menu and the checkin actions -->
        <EspPowerButton
            v-if="!isAppLevelRoute && (footerMenu.overflow.length || footerMenu.actions.length)"
            :entries="footerMenu.overflow"
            :actions="footerMenu.actions"
            @navigate="onPowerMenuNavigate"
            @action="onPowerMenuAction"
        />

        <!-- Fix for footer and left panel menu -->
        <Footer v-if="!isAppLevelRoute"/>

    </v-app>
</template>

<script>

import CONFIG from "../constants/config";
import {layoutMixin} from "../utils/layout-mixin";
import {settingsMixin} from "../utils/settings-mixin";
import {eventMixin} from "../utils/event-mixin";
import {spotMixin} from "../utils/spot-mixin";
import {teamMixin} from "../utils/team-mixin";
import {qrLoginMixin} from "../utils/qrlogin-mixin";
import {onboardingMixin} from "../utils/onboarding-mixin";
import {EventBus} from "../components/spots/EventBus";
import {EventBusNotification} from "../components/EventBusNotification";
import {DEMO_STAMP_DELAY_MS, isDemoModeEvent, shouldShowDemoStamp} from "../utils/demo-mode.mjs";
import EspSnackbar from "../components/ui/EspSnackbar.vue";
import EspDemoStamp from "../components/ui/EspDemoStamp.vue";
import EspPowerButton from "../components/ui/EspPowerButton.vue";
import EspCheckinActions from "../components/spots/EspCheckinActions.vue";
import HLConfirm from "../components/ui/HLConfirm.vue";
import Menu from "./dashboard/Menu.vue";
import Footer from "./dashboard/Footer.vue";
import WelcomeDialogPage from "./dashboard/WelcomeDialogPage.vue";

export default {
    mixins: [settingsMixin,layoutMixin,eventMixin,spotMixin,teamMixin,qrLoginMixin,onboardingMixin],
    components:{
        Menu,
        Footer,
        EspSnackbar,
        EspDemoStamp,
        EspPowerButton,
        EspCheckinActions,
        HLConfirm,
        WelcomeDialogPage
    },
    data(){
        return {
            backgroundImage:"bgImage1",
            overlay:false,
            welcomeDialogOverlay:false,
            spot:null,
            autoCheckin:false,
            hideFooter:false,
            notification:false,
            notificationText:null,
            notificationTimeout:null,
            notificationTimeoutStart:0,
            notificationActionText:null,
            notificationActionCancelText:null,
            notificationclickEvent:null,
            notificationCancelEvent:null,
            notificationOutoftimeEvent:null,
            secreEventEndedPointer:null,
            reloadContentPointer:null,
            demoDialog:false,
            demoDialogShown:false,
            demoStamp:false,
            demoSinceMs:null,
            demoStampPointer:null
        }
    },
    watch: {
        selectedEventId(){
            this.resetDemoMode();
            this.checkDemoMode();
        },
        // the event refresh (every 60 s) replaces the event object, like the UPDATE listener of the native app
        selectedEvent:{
            handler(){
                this.checkDemoMode();
            },
            immediate: true
        },
        welcomeDialogOverlay(open){
            if(!open){
                this.checkDemoMode();
            }
        },
        completeEvent:{
            handler: function(val) {
                if(val && this.selectedEventId){

                    clearTimeout(this.secreEventEndedPointer);

                    if(!this._.isEmpty(this.selectedEvent) && this.selectedEvent.active && this.completeEvent && !this.hasFinishText){
                        // if user completes event before timeout and event has no finish dialog - show nothing
                        return false;
                    }
                    this.secreEventEndedPointer=setTimeout(()=>{
                        console.log(`Timeout ended to show finish dialog. CompleteEvent: ${this.completeEvent}`);
                        if(this.completeEvent){
                            this.goToInactiveEvent(this.selectedEventId,0);
                        }
                    },5000);

                }
            },
            immediate: true
        },
        '$route': {
            //TODO evtl in einen guard auslagern in vue router
            handler: function(route) {
                if(route && route.params && route.params.id){
                    if(!this.hasSelectedEvent || route.params.id!=this.selectedEventId){
                        this.checkinEvent(route.params.id).then((event_id)=>{
                            this.loadGameContent(event_id);
                        }).catch((ex)=>{
                            console.warn(ex);
                            this.goToAccessableArea();
                        })
                    }
                    this.startEventLoop();
                }else{
                    this.goToAccessableArea();
                }
            },
            deep: true,
            immediate: true
        },
        unsolvedAutoCheckinSpots:{
            handler: function(list) {
                const spot = this.$store.state.taskpage.spot;
                if(this._.isEmpty(spot) && !this._.isEmpty(list)){
                    let first=this._.first(list);
                    this.showAutoCheckinSpot(first);
                }
            },
            deep: true,
            immediate: true
        },
        action_timers:{
            handler: function(timerList) {
                this.$eventLoop.setGroupActionTimeList(timerList)
            },
            deep: true,
            immediate: true
        },
        event_timezone:{
            handler: function(timezone) {
                this.$eventLoop.setTimezone(timezone)
            },
            deep: true,
            immediate: true
        }
    },

    computed: {
        // pages like the settings bring their own frame instead of the event header and footer
        isAppLevelRoute(){
            return !!(this.$route && this.$route.meta && this.$route.meta.appLevel);
        }
    },
    methods: {
        // selection card or list for logged-in users (never re-runs the landing, so a failing main event cannot loop)
        goToAccessableArea(){
            this.goToAccessibleArea();
        },
        loadGameContent(event_id,isReconnect=false,silent=false,loadSpots=true,loadTeam=true){

            if(!isReconnect){
                this.setCustomBackgroundBranding();
                this.showWelcomeDialog();
            }
            this.setThemeColors(event_id);

            this.getPlayerinfo().then(stat=>{
                if(this._.isEmpty(stat) || !('username' in stat)){
                    //Check if user is valid
                    this.goToAccessableArea();
                }
            });

            if(loadTeam){
                this.getTeamInfo().catch(ex=>{
                    console.log(`Can not get team info`);
                    console.log(ex);
                    EventBusNotification.$emit(CONFIG.EVENT_BUS_NOTIFICATION_SHOW,this.$t('noInternetConnectionOk'));
                });

                this.getTeamPhoto().catch(ex=>{
                    console.log(`Can not get photo of game ${event_id}`);
                    console.log(ex);
                    EventBusNotification.$emit(CONFIG.EVENT_BUS_NOTIFICATION_SHOW,this.$t('noInternetConnectionOk'));
                });
            }
            if(loadSpots){
                this.getSpotsByEventId({eventId:event_id,silent:silent}).catch(ex=>{
                    console.log(`Can not load data of game ${event_id}`);
                    console.log(ex);
                    EventBusNotification.$emit(CONFIG.EVENT_BUS_NOTIFICATION_SHOW,this.$t('noInternetConnectionOk'));
                });
            }

            this.startWebsocketSafty(event_id);
        },
        // The layout is created anew when the user returns from a page outside of it (event list,
        // legal pages). The store still holds the event, so the route watcher skips loadGameContent
        // and websocket and custom background would stay down. Reloads silently, no welcome dialog.
        resumeGameContentIfLoaded(){
            const routeEventId = (this.$route && this.$route.params) ? this.$route.params.id : null;
            if(routeEventId && this.hasSelectedEvent && String(routeEventId) === String(this.selectedEventId)){
                this.setCustomBackgroundBranding();
                this.loadGameContent(routeEventId, true, true);
            }
        },
        loadGameContentAfterLostConnecttion(event_id,offlineTimeInSeconds){
            this.reloadWelcomeDialogIfOpen();

            //reload game and also game content if offline time is > 7 seconds otherwise just reconnect websocket
            this.checkinEvent(event_id).then(()=>{
                if(offlineTimeInSeconds >= 1){
                    let loeadTeam=!this.settingsEventNeedWebsocketConnection; // only load team data if no ws is required
                    this.loadGameContent(event_id,true,true,false,loeadTeam);
                }else{
                    this.startWebsocketSafty(event_id);
                }
            });
        },
        startWebsocketSafty(event_id){
            this.stopWebsocket();
            if(this.settingsEventNeedWebsocketConnection){
                this.$websocket.connect(this.app_token,event_id);
            }
        },
        stopWebsocket(){
            this.$websocket.destroy();
        },
        startEventLoop(){
            this.$eventLoop.start();
        },
        stopEventLoop(){
            this.$eventLoop.stop();
        },
        /**
         * Demo mode like the native app: the hint once per event session (after the welcome dialog), the
         * stamp at once for forced events, otherwise DEMO_STAMP_DELAY_MS after the condition first held.
         * Re-evaluated on every event refresh, on return to the tab and by a timer at the end of the delay.
         */
        checkDemoMode(){
            const event=this.selectedEvent;
            if(this._.isEmpty(event)){
                this.demoStamp=false;
                return;
            }
            const nowMs=Date.now();
            const parseInTz=(naive,timezone)=>this.parseInEventTimezone(naive,timezone);
            const isDemo=isDemoModeEvent(event,nowMs,parseInTz);
            if(isDemo && this.demoSinceMs===null){
                this.demoSinceMs=nowMs;
                clearTimeout(this.demoStampPointer);
                this.demoStampPointer=setTimeout(()=>this.checkDemoMode(),DEMO_STAMP_DELAY_MS+1000);
            }
            if(isDemo && !this.demoDialogShown && !this.welcomeDialogOverlay){
                this.demoDialogShown=true;
                this.demoDialog=true;
            }
            this.demoStamp=shouldShowDemoStamp(event,this.demoSinceMs,nowMs,parseInTz,this.parseBoolean(CONFIG.FORCE_DEMO_STAMP,false));
        },
        resetDemoMode(){
            clearTimeout(this.demoStampPointer);
            this.demoStampPointer=null;
            this.demoSinceMs=null;
            this.demoDialogShown=false;
            this.demoDialog=false;
            this.demoStamp=false;
        },
        onVisibilityChange(){
            if(document.visibilityState==='visible'){
                this.checkDemoMode();
            }
        },
        showWelcomeDialog(){
            this.welcomeDialogOverlay=true;
        },
        onPowerMenuNavigate(entry){
            this.navigateTo({ path: entry.link });
        },
        onPowerMenuAction(key){
            EventBus.$emit(CONFIG.EVENT_BUS_OPEN_CHECKIN_ACTION, { type: key });
        },
        /**
         * A spot found by QR scan or password: the spot shown right now checks in in place, a
         * secret spot runs the auto-checkin overlay, any other spot opens like a list tap. Both
         * happen on a task page, so the player is taken there first.
         */
        onCheckinSpotVerified(spot, kind){
            if(kind === 'open'){
                EventBus.$emit(CONFIG.EVENT_BUS_CHECKIN_OPEN_SPOT, spot);
                return;
            }
            this.ensureTaskPageRoute().then(()=>{
                if(kind === 'secret'){
                    this.showAutoCheckinSpot(spot);
                }else{
                    this.$store.commit('taskpage/SetSelectViaList', true);
                    this.$store.commit('taskpage/SetSpot', spot);
                }
            });
        },
        // stays on the task or map page; otherwise the tasks entry of the bar, else its map entry, else the plain task page
        ensureTaskPageRoute(){
            if(/^\/event\/[^/]+\/(tasks(\/|$)|map$)/.test(this.$route.path)){
                return Promise.resolve();
            }
            const cells = this.footerMenu.main.filter(Boolean);
            const target = cells.find((cell) => cell.key === 'tasks') || cells.find((cell) => cell.key === 'map');
            const link = target ? target.link : `/event/${this.selectedEventId}/tasks/nomap`;
            return this.$router.push(link).catch(() => {}).then(() => this.$nextTick());
        },
        onCloseWelcomeDialog(){
            this.welcomeDialogOverlay=false;
        },
        reloadWelcomeDialogIfOpen(){
            if(this.welcomeDialogOverlay){
                this.checkinEvent(this.selectedEventId).then(()=>{
                    this.onCloseWelcomeDialog();
                    this.$nextTick(()=>{
                        this.showWelcomeDialog();
                    });
                });
            }
        },
        onSnackbarClick(){
            if(this._.isFunction(this.notificationclickEvent)){
                this.notificationclickEvent();
            }
        },
        onSnackbarCancel(){
            if(this._.isFunction(this.notificationCancelEvent)){
                this.notificationCancelEvent();
            }
        },
        onSnackbarOutoftime(){
            if(this._.isFunction(this.notificationOutoftimeEvent)){
                this.notificationOutoftimeEvent();
            }
        },
        setCustomBackgroundBranding(){
            if(!this._.isEmpty(this.customBackground)){
                this.addFixedBackgroundImageByClass(this.backgroundImage,this.customBackground);
            }
        },
        showAutoCheckinSpot(spot){
            if(!this._.isEmpty(spot)){
                this.$store.commit('taskpage/SetSingleView', true);
                this.$store.commit('taskpage/SetAutoCheckin', true);
                this.$store.commit('taskpage/SetHideFooter', true);
                this.$store.commit('taskpage/SetSpot', spot);
            }
        },
        refreshTaskView(){
            EventBus.$emit(CONFIG.EVENT_BUS_REFRESH_SPOT);
        },
        closeNotificationAndShow(msg){
            EventBusNotification.$emit(CONFIG.EVENT_BUS_NOTIFICATION_HIDE);
            this.$nextTick(()=>{
                if(!this._.isEmpty(msg)){
                    EventBusNotification.$emit(CONFIG.EVENT_BUS_NOTIFICATION_SHOW,msg);
                }
            })
        },
        registerWebsocketListener(){
            let onTeamNameChange=()=>{//person_id
                this.getTeamInfo().then(()=>{
                    //Removed by custumer request - deactivate welcome dialog sync
                    //this.reloadWelcomeDialogIfOpen();
                });
            };

            let onTeamPhotoChange=()=>{//person_id
                this.getTeamPhoto().then(()=>{
                    //Removed by custumer request - deactivate welcome dialog sync
                    //this.reloadWelcomeDialogIfOpen();
                });
            };

            this.$websocket.setCallback('onConnected',(event_id,isReconnect)=>{
                if(isReconnect){ // only on reconnect to prevent double loading on enter game
                    onTeamPhotoChange();
                    onTeamNameChange();
                }
            });

            this.$websocket.setCallback('onCheckin',(spot_id,open_in_Popup)=>{
                //this.addSpotObject(spot); this would be great - but diesnt work at the moment
                if(spot_id){
                    this.checkinSpot(spot_id,this.selectedEventId,this.selectedEvent.timezone,true);
                    if(this.isSlaveInMasterSlaveMode && open_in_Popup){
                        this.getSpotById(spot_id).then((spot)=>{
                            EventBus.$emit(CONFIG.EVENT_BUS_OPEN_SPOT,spot);
                        });
                    }
                }
            });

            this.$websocket.setCallback('onSolve',(eventId/*,spotId*/)=>{

                this.getSpotsByEventIdSilent(eventId).then(()=>{
                    this.$nextTick(()=>{
                        this.refreshTaskView();
                    });
                });
            });

            this.$websocket.setCallback('onTeamPhotoChange',onTeamPhotoChange);
            this.$websocket.setCallback('onTeamNameChange',onTeamNameChange);

            this.$websocket.setCallback('onLeaderChange',(person_id,agree)=>{

                if(agree){
                    //Reload teaminfo to get new teamleader and show a notification
                    this.getTeamInfo().then(()=>{
                        let teamMember=this.$store.getters['events/teamMemberById'](person_id);
                        if(teamMember){
                            try{
                                //show notification
                                let label = (person_id==this.userId)?this.$t('app_team_master_changed_to_me'):this.$t('app_team_master_changed_to',{leader_new_name:teamMember.name});
                                EventBusNotification.$emit(CONFIG.EVENT_BUS_NOTIFICATION_SHOW,label);
                                this.hasOpenTeamLeaderRequestNotification=false;
                            }catch(ex){console.log(ex)}
                        }
                    });
                }else{
                    if(this.hasLeaderChangeRequest){
                        this.closeNotificationAndShow(this.$t('app_team_master_requested_change_denied'));
                    }
                }
                this.resetTeamLeaderChange();
            });

            this.$websocket.setCallback('onLeaderChangeRequest',(person_id,time_utc,abort)=>{

                //cancel upcoming leader change requests of other teamplayers
                if(this.isSlaveInMasterSlaveMode){
                    if(this.hasLeaderChangeRequest){
                        if((time_utc<this.leaderChangeRequest.time_utc) || abort){
                            //other player was faster - deny my request by my own
                            this.closeNotificationAndShow(this.$t('app_team_master_requested_change_denied_by_faster_teammate'));
                            this.resetTeamLeaderChange();
                        }else{
                            //I was the fastes requester. send deny to all others
                            this.sendTeamleaderChangeAbort();
                        }
                    }
                } else if(this.isTeamLeaderInMasterSlaveMode && !this.hasOpenTeamLeaderRequestNotification){
                    this.hasOpenTeamLeaderRequestNotification=true;
                    let teamMember=this.teamMemberById(person_id);
                    if(teamMember){
                        let timeDelayOfRequest=(time_utc)?new Date().getTime()-new Date(time_utc).getTime():0;
                        EventBusNotification.$emit(CONFIG.EVENT_BUS_NOTIFICATION_SHOW,this.$t('app_team_master_requested_change_question',{leader_new_name:teamMember.name}),this.$t('yes'),this.$t('no'),process.env.VUE_APP_TEAMLEADER_RESPONSE_TIME,timeDelayOfRequest,()=>{
                                //Yes - agree with new leader
                                this.notifyTeamleaderChanged(person_id,true);
                            },
                            ()=>{
                                //No - deny leader change request
                                this.notifyTeamleaderChanged(person_id,false);
                            });
                    }
                }
            });
        },
        unregisterWebsocketListener(){

            this.$websocket.setCallback('onConnected',()=>{});
            this.$websocket.setCallback('onCheckin',()=>{});
            this.$websocket.setCallback('onSolve',()=>{});
            this.$websocket.setCallback('onTeamPhotoChange',()=>{});
            this.$websocket.setCallback('onTeamNameChange',()=>{});
            this.$websocket.setCallback('onLeaderChange',()=>{});
            this.$websocket.setCallback('onLeaderChangeRequest',()=>{});
        },
        registerConnectionListener(){
            this.$connection.$on("connection", (online,lastConnectedTime,lastDisconnectedTime,offlineTimeInSeconds) => {
                if(online){
                    //Refresh in background - maybe it is good to prevent reloads if connection is toggling between on and off
                    this.loadGameContentAfterLostConnecttion(this.selectedEventId,offlineTimeInSeconds);
                    console.log(`Offline time: ${offlineTimeInSeconds}`);
                }else{
                    this.stopWebsocket();
                }
            });
        },
        unregisterConnectionListener(){
            this.$connection.$off("connection");
        },
        registerEventListener(){
            EventBus.$on(CONFIG.EVENT_BUS_OPEN_SPOT, (spot) => {

                const autoCheckin=(this.isInfoSpot(spot) && this.isSecretSpot(spot));
                this.$store.commit('taskpage/SetSingleView', true);
                this.$store.commit('taskpage/SetAutoCheckin', autoCheckin);
                this.$store.commit('taskpage/SetHideFooter', autoCheckin);
                this.$store.commit('taskpage/SetSpot', spot);

                // the teammates of a teamleader open the spot as well
                this.notifyMasterSlaveTeamPlayersForCheckin(spot,true);
            });
            EventBus.$on(CONFIG.EVENT_BUS_CLOSE_SPOT, () => {
                //Close overlay

                this.$store.commit('taskpage/resetState');
                // normal and singleView closes meet here; a reopened spot starts its audio from the top
                this.$store.dispatch('taskaudio/stop');

                this.$store.dispatch('spots/updateLists');

            });
            EventBusNotification.$on(CONFIG.EVENT_BUS_NOTIFICATION_SHOW, (text,actionText='OK',actionCancelText='',timeoutInSeconds=5,timeoutDelayInMs=0,onClick=null,onCancel=null,onSnackbarOutoftime=null) => {

                if(this.$refs.espSnackbar){
                    this.notification=false;
                    this.$refs.espSnackbar.stopSyncPbar();
                }
                this.$nextTick(()=>{
                    this.notificationTimeout=timeoutInSeconds*1000;
                    this.notificationTimeoutStart=timeoutDelayInMs;
                    this.notificationActionText=actionText;
                    this.notificationActionCancelText=actionCancelText;
                    this.notificationText=text;
                    this.notificationclickEvent=onClick;
                    this.notificationCancelEvent=onCancel;
                    this.notificationOutoftimeEvent=onSnackbarOutoftime;
                    this.notification=true;
                });

            });
            EventBusNotification.$on(CONFIG.EVENT_BUS_NOTIFICATION_HIDE,()=>{
                this.notification=false;
            })
        },
        unregisterEventListener(){
            EventBus.$off(CONFIG.EVENT_BUS_OPEN_SPOT);
            EventBus.$off(CONFIG.EVENT_BUS_CLOSE_SPOT);
            EventBusNotification.$off(CONFIG.EVENT_BUS_NOTIFICATION_SHOW);
        },
    },
    mounted(){
        document.documentElement.classList.add('event-layout');
        this.addFixedBackgroundImageByClass(this.backgroundImage);
        this.registerConnectionListener();
        this.registerEventListener();
        this.registerWebsocketListener();
        this.resumeGameContentIfLoaded();
        document.addEventListener('visibilitychange',this.onVisibilityChange);
    },
    beforeDestroy(){
        document.documentElement.classList.remove('event-layout');
        document.removeEventListener('visibilitychange',this.onVisibilityChange);
        clearTimeout(this.demoStampPointer);
        this.removeFixedBackgroundImageByClass(this.backgroundImage);
        this.unregisterEventListener();
        this.unregisterWebsocketListener();
        this.unregisterConnectionListener();
        this.stopEventLoop();
        this.stopWebsocket();
    }
}
</script>

<style>
/*
 * The game never scrolls as a document. The shell is exactly as tall as the visible viewport
 * (a 100% chain down from <html> instead of Vuetify's min-height: 100vh, which iOS Safari
 * measures with its toolbar collapsed), the page takes the space between header and footer
 * and clips what it cannot show, so every page has to scroll inside its own container.
 */
html.event-layout,
html.event-layout body,
html.event-layout #app,
html.event-layout .v-application {
    height: 100%;
}
html.event-layout {
    overflow: hidden;
    overscroll-behavior: none;
}
html.event-layout .v-application--wrap {
    height: 100%;
    min-height: 0;
    overflow: hidden;
}
.v-application .event-page {
    display: flex;
    flex-direction: column;
    flex: 1 1 auto;
    min-height: 0;
    overflow: hidden;
}
.v-application .event-page > * {
    flex: 1 1 auto;
    min-height: 0;
}

.slide-fade-enter-active {
    transition: all 2s ease;
}
.slide-fade-leave-active {
    transition: all .8s cubic-bezier(1.0, 0.5, 0.8, 1.0);
}
.slide-fade-enter, .slide-fade-leave-to
    /* .slide-fade-leave-active below version 2.1.8 */ {
    transform: translateY(30px);
    opacity: 0;
}
</style>